import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../../shared/shared.service';
import { SnackBarService } from '../../../common-services/snack-bar.service';

@Component({
  selector: 'app-local-purchase-invoice',
  templateUrl: './local-purchase-invoice.component.html',
  styleUrls: ['./local-purchase-invoice.component.css']
})
export class LocalPurchaseInvoiceComponent  {
  public data: any;
  constructor(
    public dialogRef: MatDialogRef<LocalPurchaseInvoiceComponent>,
    public sharedService: SharedService,
    public notification: SnackBarService,
    @Inject(MAT_DIALOG_DATA) private confModel: any
  ) {
    this.data = confModel.data.data; 
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
